import React, { useState } from "react";
import BlueSmallButton from "../../components/customButtons/BlueSmallButton";
import { Box, Grid, Typography } from "@mui/material";

import GlobalCard from "../../components/GlobalCardComponent";
import PrimarySmallBlueButton from "../../components/customButtons/PrimarySmallBlueButton";
import CustomPopup from "../../components/customPopup/CustomPopup";
import BookDemoForm from "../allClasses/BookDemoForm";
import ConfimationPopup from "../../components/customPopup/ConfimationPopup";
import GlobalMessageModal from "../../components/customPopup/GlobalMessageModal";
import ArticleIcon from "@mui/icons-material/Article";
export default function NoUpcomingDemoPage() {
  const [openBookDemo, setOpenBookDemo] = useState(false);
  const [openSuccesPopup, setOpenSuccesPopup] = useState(false);
  // Book Demo
  const handleOpenBookDemo = () => {
    setOpenBookDemo(true);
  };

  const handleCloseBookDemo = () => {
    setOpenBookDemo(false);
  };

  const handleOpenSuccessPopup = () => setOpenSuccesPopup(true);
  const handleCloseSuccessPopup = () => setOpenSuccesPopup(false);
  return (
    <>
      <Box
        sx={{
          maxWidth: "100%",
          mx: "20px",
          my: 3,
          p: 8,
          px: { xs: 2, sm: 7, md: 15 },
          textAlign: "center",
          borderRadius: 4,
          backgroundColor: "#fff",
          boxShadow: "0 2px 12px rgba(0,0,0,0.1)",
          position: "relative",
        }}
      >
        <Box
          position="absolute"
          top={0}
          left={0}
          sx={{
            width: "90px",
            borderTopLeftRadius: "15px",
            borderTopRightRadius: "2px",
            overflow: "hidden",
          }}
        >
          <img
            src="/newdashboard/Wishlist/Ellipse 9241.png"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              display: "block",
            }}
          />
        </Box>
        <Box
          position="absolute"
          bottom={0}
          right={0}
          sx={{
            width: "90px",
            borderBottomRightRadius: "15px",
            borderBottomLeftRadius: "2px",
            overflow: "hidden",
          }}
        >
          <img
            src="/newdashboard/Wishlist/Ellipse 9240.png"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              display: "block",
            }}
          />
        </Box>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box
              sx={{
                width: 150,
                height: 150,
                mx: "auto",
                mb: 2,
                borderRadius: "50%",
                backgroundColor: "#fce8f3",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img src="/newdashboard/Demo/Visionaries sit on giant light bulbs and look through binoculars 1.png" />
            </Box>
          </Grid>

          {/* Title */}
          <Grid item xs={12}>
            {" "}
            <Typography
              fontSize="26px"
              color="#9D0385"
              sx={{
                fontWeight: 700,
                fontFamily: "Inters",
                fontStyle: "normal",
                letterSpacing: "0px",
                verticalAlign: "middle",
                lineHeight: "100%",
              }}
            >
              No Upcoming Demo Scheduled
            </Typography>
          </Grid>

          {/* Subtitle */}
          <Grid item xs={12}>
            {" "}
            <Typography
              fontSize="16px"
              color="#555555"
              sx={{
                fontWeight: 400,
                fontFamily: "Inter",
                fontStyle: "normal",
                letterSpacing: "0px",
                verticalAlign: "middle",
                lineHeight: 1.5,
              }}
            >
              You don’t have any upcoming demo classes right now. Book a slot to
              get started.
            </Typography>
          </Grid>

          {/* Button */}
          <Grid item xs={12} mt={2}>
            {" "}
            <PrimarySmallBlueButton
              buttonTitle="Book Demo"
              width="209px"
              onClick={handleOpenBookDemo}
            />
          </Grid>
        </Grid>
      </Box>

      <CustomPopup
        handleClose={handleCloseBookDemo}
        component={
          <BookDemoForm
            handleClose={handleCloseBookDemo}
            handleOpenSuccessPopup={handleOpenSuccessPopup}
          />
        }
        open={openBookDemo}
        title="Book a demo session"
        titleColor="#000000"
        maxWidth="md"
        titleAlign="center"
      />

      <ConfimationPopup
        handleClose={handleCloseSuccessPopup}
        component={
          <GlobalMessageModal
            handleClose={handleCloseSuccessPopup}
            const
            text="Demo Session Booked !."
            subText="Your demo session has been booked. We’ve reserved your slot and shared the details with you."
            buttonTitle="View Demo"
            startIcon={<ArticleIcon />}
            navigateLink="/test-prep/demos"
             currentLink="/test-prep/demos"
          />
        }
        open={openSuccesPopup}
        subtitle=""
        maxWidth="sm"
      />
    </>
  );
}
